export default __webpack_public_path__ + "static/image-4-423b8d30457c84f770579944aa9039b1.jpg";